import { Injectable } from '@angular/core';
import { Rechte } from '../model/rechte.model';
import { Verfahren } from '../model/verfahren';
import { KundenTypeEnum } from '../model/kunden-type.enum';
import {ActingOnBehalfKontoStatusEnum} from "../model/acting-on-behalf-konto-status.enum";

export class MissingUserRightsError extends Error {
    constructor() {
        super('UserAccountService: benutzerRechte wurden nicht gesetzt.');
        this.name = 'MissingUserRightsError';
    }
}

@Injectable({ providedIn: 'root' })
export class UserAccountService {
    private benutzerRechte: Rechte | null = null;

    setUserAccount(benutzerRechte: Rechte): void {
        this.benutzerRechte = benutzerRechte;
    }

    getUserAccount(): Rechte {
        return this.requireRechte();
    }

    hasUserAccount(): boolean {
        return this.benutzerRechte !== null;
    }


    isKindergeldFall(): boolean {
        const r = this.requireRechte();
        return r.kundenTyp === KundenTypeEnum.KINDERGELDFALL;
    }

    isStepBetrieb(): boolean {
        const r = this.requireRechte();
        return r.kundenTyp === KundenTypeEnum.BETRIEB;
    }

    isStepPerson(): boolean {
        const r = this.requireRechte();
        return r.kundenTyp === KundenTypeEnum.PERSON;
    }

    isStepUser(): boolean {
        const r = this.requireRechte();
        return r.kundenTyp === KundenTypeEnum.PERSON || r.kundenTyp === KundenTypeEnum.BETRIEB;
    }

    isZuwanderungsinteressierter(): boolean {
        const r = this.requireRechte();
        return r.kundenTyp === KundenTypeEnum.ZUWANDERUNGSINTERESSIERTER;
    }

    getVerfahren(): Verfahren | null {
        const r = this.requireRechte();
        switch (r.kundenTyp) {
            case KundenTypeEnum.ZUWANDERUNGSINTERESSIERTER:
                return Verfahren.ZAV;
            case KundenTypeEnum.PERSON:
            case KundenTypeEnum.BETRIEB:
                return Verfahren.STEP;
            case KundenTypeEnum.KINDERGELDFALL:
                return Verfahren.KIWI;
            default:
                return null;
        }
    }

    isRestricted(): boolean {
        const r = this.requireRechte();
        return (
            !r.actingOnBehalfOnlineKommunikation
        );
    }

    isSelf(identity:string):boolean{
        const r = this.requireRechte();
        return r.identity === identity;
    }

    private requireRechte(): Rechte {
        if (!this.benutzerRechte) {
            throw new MissingUserRightsError();
        }
        return this.benutzerRechte;
    }
}